import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "../../lib/axios";
import { API_ROUTES, QUERY_KEYS } from "../constants";

import type { BudgetData } from "../types";

interface UseBudgetOptions {
  organizationId?: number;
  enabled?: boolean;
  refetchOnWindowFocus?: boolean | "always";
  staleTime?: number;
}

export const useBudget = (options?: UseBudgetOptions) => {
  return useQuery({
    queryKey: QUERY_KEYS.budget(options?.organizationId),
    queryFn: async () => {
      const response = await axiosInstance.get<BudgetData>(API_ROUTES.budget, {
        params: {
          ...(options?.organizationId != null && {
            organization_id: options.organizationId,
          }),
        },
      });
      return response.data;
    },
    enabled: options?.enabled,
    refetchOnWindowFocus: options?.refetchOnWindowFocus,
    staleTime: options?.staleTime,
  });
};
